<template lang="pug">
  .column
    .text-center.text-big.m4-top-6.m4-bottom-6(v-if='showFilterResults')
      span.text-big.dark-gray.inline {{ $t('searchProgramResults.weFind') }}
      span.text-big.blue.bold.inline(v-if='showFilterResults')
        | {{ $tc('searchProgramResults.educationalPrograms', totalCount) }}
      span.text-big.dark-gray.inline {{ $t('searchProgramResults.yourSearch') }}
    .empty-results.column.center.width-100.m4-top-14(v-if='!existsPrograms')
      img.empty-icon.m-bottom-2(src='../../assets/ic_search_empty.png' alt='No Results')
      p.error-title.title-medium.bold.dark-gray.m-bottom-2 {{ $t('searchProgramResults.errors.noResult') }}
      p.error-explanation.text-big.dark-gray
        | {{ $t('searchProgramResults.errors.emptySearchResultExplanation') }}
      button.text-small.blue.m-top-4(type='button' @click='clearSearchedPrograms')
        | {{ $t('searchProgramResults.backToSearch') }}
</template>

<script>
import { mapActions } from 'vuex'
import userRole from '../../mixins/userRole'

export default {
  mixins: [userRole],
  props: {
    totalCount: { type: Number, default: 0, required: true },
    searchedPrograms: { type: Boolean }
  },
  computed: {
    showFilterResults() {
      return this.searchedPrograms && this.totalCount !== 0
    },
    existsPrograms() {
      return this.totalCount
    }
  },
  methods: {
    ...mapActions([
      'setNavigationOptions'
    ]),
    clearSearchedPrograms() {
      this.$emit('clearFilters')
      this.setNavigationOptions({ option: 'list' })
      this.$router.push({ name: 'educationalPrograms', params: { hasReloaded: false } })
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-icon {
  margin-top: 8px;
  max-width: 204px;
}

.error-title {
  max-width: 304px;
}

.error-explanation {
  max-width: 660px;
  text-align: center;
}

.resources-results {
  .card-container {
    margin: 0 10px 20px;
  }
}
</style>
